<template>
<div>

  <!-- 面包屑导航区域-->
  <el-breadcrumb separator-class="el-icon-arrow-right">
    <el-breadcrumb-item :to="{ path: '/home' }">Homepage</el-breadcrumb-item>
    <el-breadcrumb-item>RFQ Forwarder</el-breadcrumb-item>
    <el-breadcrumb-item>File Management</el-breadcrumb-item>
  </el-breadcrumb>

  <!--卡片视图区域-->

  <el-card>
    <el-form :inline="true" :model="formInline" class="demo-form-inline">
      <el-form-item label="RGL File Name:">
        <el-select v-model="formInline.fglFileName" collapse-tags
              style="margin-left: 0px;"
              placeholder="please choose">
            <el-option
            v-for="item in this.fglFileNameSelection"
            :key="item"
            :label="item"
            :value="item">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">Search</el-button>
      </el-form-item>
    </el-form>
    <el-button style="margin-bottom: 10px;margin-top: 10px" type="primary"  @click="delRfqTbl2Db">File Delete</el-button>
    <el-table :data="this.rglData" border style="width: 100%">
      <el-table-column
        prop="rglFileName"
        label="RGL File"
        width="90">
      </el-table-column>
          <el-table-column property="freightCost" label="Freight Cost" width="125" :show-overflow-tooltip="true">
            <template slot-scope="scope">
            <el-input v-if="scope.row.flag==='add' || scope.row.flag==='edit'" v-model="scope.row.freightCost" size="mini"></el-input>
            <div v-if="scope.row.flag==='view'">{{scope.row.freightCost}}</div>
            </template>
          </el-table-column>
          <el-table-column property="freightForwName" label="Freight Forwarder" width="135" :show-overflow-tooltip="true">
            <template slot-scope="scope">
            <el-input v-if="scope.row.flag==='add' || scope.row.flag==='edit'" v-model="scope.row.freightForwName" size="mini"></el-input>
            <div v-if="scope.row.flag==='view'">{{scope.row.freightForwName}}</div>
            </template>
          </el-table-column>
          <el-table-column property="currency" label="Currency" width="136">
            <template slot-scope="scope">
            <el-select v-if="scope.row.flag==='add' || scope.row.flag==='edit'" v-model="scope.row.currency"  size="mini" placeholder="Please choose">
              <el-option
                v-for="item in currencyArr"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
              </el-select>
              <div  v-if="scope.row.flag==='view'">{{scope.row.currency}}</div>
              </template>
          </el-table-column>
           <el-table-column property="approval" label="Approval" width="136">
             <template slot-scope="scope">
              <el-switch v-if="scope.row.flag==='add' || scope.row.flag==='edit'" size="mini"
                style="display: block"
                v-model="scope.row.approval"
                active-color="#13ce66"
                inactive-color="#ff4949"
                active-text="Yes"
                inactive-text="No">
              </el-switch>
              <div  v-if="scope.row.flag==='view'">{{scope.row.approval}}</div>
              </template>
            </el-table-column>
            <el-table-column property="packingListNbr" label="Packing List" width="136">
              <template slot-scope="scope">
              <el-select v-if="scope.row.flag==='add' || scope.row.flag==='edit'" v-model="scope.row.packingListNbr" collapse-tags
                    style="margin-left: 0px;" filterable size="mini"
                    placeholder="please choose">
                  <el-option
                  v-for="item in packingList"
                  :key="item"
                  :label="item"
                  :value="item">
                </el-option>
              </el-select>
              <div  v-if="scope.row.flag==='view'">{{scope.row.packingListNbr}}</div>
              </template>
              </el-table-column>
              <el-table-column property="etd" label="ETD" width="136">
                <template slot-scope="scope">
                        <el-date-picker v-if="scope.row.flag==='add' || scope.row.flag==='edit'"
                          v-model="scope.row.etd" value-format="yyyy-MM-dd" size="mini"
                          type="date"
                          placeholder="ETD">
                        </el-date-picker>
                        <div  v-if="scope.row.flag==='view'">{{ dateFormat1(scope.row.etd) }}</div>
                        </template>
              </el-table-column>
              <el-table-column property="eta" label="ETA" width="136"   :formatter="dateFormat">
                <template slot-scope="scope">
                        <el-date-picker v-if="scope.row.flag==='add' || scope.row.flag==='edit'"
                          v-model="scope.row.eta" value-format="yyyy-MM-dd" size="mini"
                          type="date"
                          placeholder="ETA">
                        </el-date-picker>
                        <div  v-if="scope.row.flag==='view'">{{dateFormat1(scope.row.eta) }}</div>
                        </template>
              </el-table-column>
          <el-table-column label="operation" width="170">
                  <template slot-scope="scope">
                    <el-button v-if="scope.row.flag==='view'" type="info" plain size="mini" @click="viewRfqFile(scope.row.rglFileName)">View</el-button>
                    <el-button v-if="scope.row.flag==='view'" type="info" plain size="mini" @click="editRfqTblRow(scope.row.rglFileName)">Edit</el-button>
                    <el-button v-if="scope.row.flag==='edit'" type="info" plain size="mini" @click="updateRfqTblRow2Db(scope.row)">Update</el-button>
                    <el-button type="info" plain size="mini" @click="delRfqTbl2Db(scope.row.rglFileName)">Delete</el-button>
                    </template>
                </el-table-column>
          </el-table>
    <!-- <div class="div-class1">
      Freight Cost: {{this.rglData[0].freightCost}}
      </div> -->
      <el-button style="margin-bottom: 10px;margin-top: 10px" type="primary" @click="addRfqRow">Add new</el-button>
      <el-tag style="margin-bottom: 10px;margin-left: 10px;"><span style="font-size:10px;">Net CBM:</span>{{ this.netCbm }} ,&nbsp; Gross CBM:{{ this.grossCbm }}</el-tag>
      <!-- Schedule 列表区域 -->
      <!-- <el-button style="margin-bottom: 10px;" type="primary" @click="addRfqRow">Add new</el-button> -->
      <el-table :data="this.multipleSelection" border stripe style="width: 100%">
            <el-table-column type="index" label="#"></el-table-column>
            <el-table-column property="status" label="Status" width="85" :show-overflow-tooltip="true">
              <template slot-scope="scope">
              <el-input  v-if="scope.row.flag==='add' || scope.row.flag==='edit'" v-model="scope.row.status" size="mini"></el-input>
              <div  v-if="scope.row.flag==='view'">{{scope.row.status}}</div>
              </template>
            </el-table-column>
            <el-table-column property="schDate1" label="Sch Date1" width="120"   :formatter="dateFormat">
              <template slot-scope="scope">
                      <el-date-picker v-if="scope.row.flag==='add' || scope.row.flag==='edit'"
                        v-model="scope.row.schDate1"   size="mini" value-format="yyyy-MM-dd"
                        type="date"
                        placeholder="Sch Date1">
                      </el-date-picker>
                      <div  v-if="scope.row.flag==='view'">{{ dateFormat1(scope.row.schDate1) }}</div>
                      </template>
            </el-table-column>

            <el-table-column property="supplier" label="Supplier" width="100" :show-overflow-tooltip="true">
              <template slot-scope="scope">
              <el-input  v-if="scope.row.flag==='add' || scope.row.flag==='edit'" v-model="scope.row.supplier" size="mini"></el-input>
              <div  v-if="scope.row.flag==='view'">{{scope.row.supplier}}</div>
              </template>
            </el-table-column>
            <el-table-column property="brand" label="Brand" width="79"  :show-overflow-tooltip="true">
              <template slot-scope="scope">
              <el-input  v-if="scope.row.flag==='add' || scope.row.flag==='edit'" v-model="scope.row.brand" size="mini"></el-input>
              <div  v-if="scope.row.flag==='view'">{{scope.row.brand}}</div>
              </template>
            </el-table-column>
            <el-table-column property="intnlRef" label="Internal reference" width="170"  :show-overflow-tooltip="true">
              <template slot-scope="scope">
              <el-input  v-if="scope.row.flag==='add' || scope.row.flag==='edit'" v-model="scope.row.intnlRef" size="mini" maxlength=50></el-input>
              <div  v-if="scope.row.flag==='view'">{{scope.row.intnlRef}}</div>
              </template>
            </el-table-column>
            <el-table-column property="item" label="Item" width="90"  :show-overflow-tooltip="true">
              <template slot-scope="scope">
              <el-input  v-if="scope.row.flag==='add' || scope.row.flag==='edit'" v-model="scope.row.item" size="mini" maxlength=50></el-input>
              <div  v-if="scope.row.flag==='view'">{{scope.row.item}}</div>
              </template>
            </el-table-column>
            <el-table-column property="itemDesc" label="Item Description" width="139"  :show-overflow-tooltip="true">
              <template slot-scope="scope">
              <el-input  v-if="scope.row.flag==='add' || scope.row.flag==='edit'" v-model="scope.row.itemDesc" size="mini" maxlength=250></el-input>
              <div  v-if="scope.row.flag==='view'">{{scope.row.itemDesc}}</div>
              </template>
            </el-table-column>
            <el-table-column property="schQ1" label="Sch. Q1" width="100"  :show-overflow-tooltip="true">
              <template slot-scope="scope">
              <el-input  v-if="scope.row.flag==='add' || scope.row.flag==='edit'" v-model="scope.row.schQ1" size="mini" maxlength=10></el-input>
              <div  v-if="scope.row.flag==='view'">{{scope.row.schQ1}}</div>
              </template>
            </el-table-column>
            <el-table-column property="length" label="Length" width="90">
              <template slot-scope="scope">
              <el-input  v-if="scope.row.flag==='add' || scope.row.flag==='edit'" v-model="scope.row.length" size="mini" @blur="checkNum($event)" maxlength=10></el-input>
              <div  v-if="scope.row.flag==='view'">{{scope.row.length}}</div>
              </template>
            </el-table-column>
            <el-table-column property="width" label="Width" width="80">
              <template slot-scope="scope">
              <el-input  v-if="scope.row.flag==='add' || scope.row.flag==='edit'" v-model="scope.row.width" size="mini" @blur="checkNum($event)" maxlength=10></el-input>
              <div  v-if="scope.row.flag==='view'">{{scope.row.width}}</div>
              </template>
            </el-table-column>
            <el-table-column property="height" label="Height" width="90">
              <template slot-scope="scope">
              <el-input  v-if="scope.row.flag==='add' || scope.row.flag==='edit'" v-model="scope.row.height" size="mini" @blur="checkNum($event)" maxlength=10></el-input>
              <div  v-if="scope.row.flag==='view'">{{scope.row.height}}</div>
              </template>
            </el-table-column>
            <el-table-column property="carton" label="Carton" width="90" :formatter="numFormat">
              <template slot-scope="scope">
              <el-input  v-if="scope.row.flag==='add' || scope.row.flag==='edit'" v-model="scope.row.carton" size="mini" @blur="checkNum($event)" maxlength=10></el-input>
              <div  v-if="scope.row.flag==='view'">{{scope.row.carton}}</div>
              </template>
            </el-table-column>

            <el-table-column property="nw" label="NW" width="90">
              <template slot-scope="scope">
              <el-input  v-if="scope.row.flag==='add' || scope.row.flag==='edit'" v-model="scope.row.nw" size="mini" @blur="checkNum($event)" maxlength=10></el-input>
              <div  v-if="scope.row.flag==='view'">{{scope.row.nw}}</div>
              </template>
            </el-table-column>

            <el-table-column property="gw" label="GW" width="90">
              <template slot-scope="scope">
              <el-input  v-if="scope.row.flag==='add' || scope.row.flag==='edit'" v-model="scope.row.gw" size="mini" @blur="checkNum($event)" maxlength=10></el-input>
              <div  v-if="scope.row.flag==='view'">{{scope.row.gw}}</div>
              </template>
            </el-table-column>

            <el-table-column property="volumn" label="Volume (CBM)" width="110">
              <template slot-scope="scope">
              <el-input  v-if="scope.row.flag==='add' || scope.row.flag==='edit'" v-model="scope.row.volumn" size="mini" @blur="checkNum($event)" maxlength=10></el-input>
              <div  v-if="scope.row.flag==='view'">{{scope.row.volumn}}</div>
              </template>
            </el-table-column>

            <el-table-column property="soldTo" label="Sold to" width="90">
              <template slot-scope="scope">
              <el-input  v-if="scope.row.flag==='add' || scope.row.flag==='edit'" v-model="scope.row.soldTo" size="mini" maxlength=50></el-input>
              <div  v-if="scope.row.flag==='view'">{{scope.row.soldTo}}</div>
              </template>
            </el-table-column>

            <el-table-column property="deliveryAddr" label="Delivery address" width="130">
              <template slot-scope="scope">
              <el-input  v-if="scope.row.flag==='add' || scope.row.flag==='edit'" v-model="scope.row.deliveryAddr" size="mini" maxlength=50></el-input>
              <div  v-if="scope.row.flag==='view'">{{scope.row.deliveryAddr}}</div>
              </template>
            </el-table-column>

            <el-table-column property="incotermCity" label="Incoterm City" width="136">
              <template slot-scope="scope">
              <el-input  v-if="scope.row.flag==='add' || scope.row.flag==='edit'" v-model="scope.row.incotermCity" size="mini" maxlength=50></el-input>
              <div  v-if="scope.row.flag==='view'">{{scope.row.incotermCity}}</div>
              </template>
            </el-table-column>

            <!-- <el-table-column property="freightCost" label="Freight Cost" width="136">
              <template slot-scope="scope">
              <el-input v-if="scope.row.flag==='add' || scope.row.flag==='edit'" v-model="scope.row.freightCost" size="mini" maxlength=10></el-input>
              <div  v-if="scope.row.flag==='view'">{{scope.row.freightCost}}</div>
              </template>
            </el-table-column>
            <el-table-column property="freightForwName" label="Freight forwarder" width="136">
              <template slot-scope="scope">
              <el-input v-if="scope.row.flag==='add' || scope.row.flag==='edit'"  v-model="scope.row.freightForwName" size="mini" maxlength=50></el-input>
              <div  v-if="scope.row.flag==='view'">{{scope.row.Freight Forwarder}}</div>
              </template>
            </el-table-column>

            <el-table-column property="currency" label="Currency" width="136">
              <template slot-scope="scope">
              <el-select v-if="scope.row.flag==='add' || scope.row.flag==='edit'" v-model="scope.row.currency" placeholder="Please choose" size="mini">
                <el-option
                  v-for="item in currencyArr"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
                </el-select>
                <div  v-if="scope.row.flag==='view'">{{scope.row.currency}}</div>
                </template>
            </el-table-column>

             <el-table-column property="approval" label="Approval" width="136">
               <template slot-scope="scope">
                <el-switch v-if="scope.row.flag==='add' || scope.row.flag==='edit'"
                  style="display: block"   size="mini"
                  v-model="scope.row.approval"
                  active-color="#13ce66"
                  inactive-color="#ff4949"
                  active-text="Yes"
                  inactive-text="No">
                </el-switch>
                <div  v-if="scope.row.flag==='view'">{{scope.row.approval}}</div>
                </template>
              </el-table-column>
              <el-table-column property="packingListNbr" label="Packing List" width="136">
                <template slot-scope="scope">
                <el-select v-if="scope.row.flag==='add' || scope.row.flag==='edit'" v-model="scope.row.packingListNbr" collapse-tags
                      style="margin-left: 0px;" filterable   size="mini"
                      placeholder="please choose">
                    <el-option
                    v-for="item in packingList"
                    :key="item"
                    :label="item"
                    :value="item">
                  </el-option>
                </el-select>
                <div  v-if="scope.row.flag==='view'">{{scope.row.packingListNbr}}</div>
                </template>
                </el-table-column>
                <el-table-column property="etd" label="ETD" width="136">
                  <template slot-scope="scope">
                          <el-date-picker v-if="scope.row.flag==='add' || scope.row.flag==='edit'"
                            v-model="scope.row.etd"   size="mini" value-format="yyyy-MM-dd"
                            type="date"
                            placeholder="ETD">
                          </el-date-picker>
                          <div  v-if="scope.row.flag==='view'">{{ dateFormat1(scope.row.etd) }}</div>
                          </template>
                </el-table-column>
                <el-table-column property="eta" label="ETA" width="136"   :formatter="dateFormat">
                  <template slot-scope="scope">
                          <el-date-picker v-if="scope.row.flag==='add' || scope.row.flag==='edit'"
                            v-model="scope.row.eta"   size="mini" value-format="yyyy-MM-dd"
                            type="date"
                            placeholder="ETA">
                          </el-date-picker>
                          <div  v-if="scope.row.flag==='view'">{{dateFormat1(scope.row.eta) }}</div>
                          </template>
                </el-table-column> -->
                <el-table-column label="operation" width="170">
                  <template slot-scope="scope">
                    <el-button v-if="scope.row.flag==='view'" type="info" plain size="mini" @click="editRfqRow(scope.row.id)">Edit</el-button>
                    <el-button v-if="scope.row.flag==='add'" type="info" plain size="mini" @click="addRfqRow2Db(scope.row)">Add</el-button>
                    <el-button v-if="scope.row.flag==='edit'" type="info" plain size="mini" @click="updateRfqRow2Db(scope.row)">Update</el-button>
                    <el-button type="info" plain size="mini" @click="delRfqRow2Db(scope.row)">Delete</el-button>
                    </template>
                </el-table-column>
          </el-table>

          <!-- 分页区域-->
           <!-- <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="formInline.page"
                :page-sizes="[10, 20, 30, 50, 100, total]"
                :page-size="formInline.rows"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total">
              </el-pagination> -->
  </el-card>
  </div>
</template>

<script>
export default {
  data () {
    return {
      formInline: {
        fglFileName: ''
      },
      userName: '',
      rglData: [],
      fglFileNameList: [],
      packingList: [],
      fglFileNameSelection: [],
      total: 0,
      updateTime: '',
      brandParam: {
        userName: '',
        userType: ''
      },
      currencyArr: [{
        value: 'USD',
        label: 'USD'
      }, {
        value: 'EUR',
        label: 'EUR'
      }, {
        value: 'RMB',
        label: 'RMB'
      }],
      netCbm: 0,
      grossCbm: 0,
      multipleSelection: [],
      oldVolumn: [],
      rgl: {
        idx: -1,
        id: -1,
        rglFileName: '',
        status: '',
        schDate1: null,
        supplier: '',
        brand: '',
        intnlRef: '',
        item: '',
        itemDesc: '',
        schQ1: '',
        length: '',
        width: '',
        height: '',
        carton: '',
        nw: '',
        gw: '',
        volumn: '',
        soldTo: '',
        deliveryAddr: '',
        incotermCity: '',
        // freightCost: '',
        // freightForwName: '',
        // currency: '',
        // approval: true,
        // packingListNbr: '',
        // etd: null,
        // eta: null,
        flag: 'view'
      },
      index: 0,
      currRglName: '',
      cbmNoPrecise: 0,
      rglTbl: {
        rglFileName: '',
        freightCost: '',
        freightForwName: '',
        currency: '',
        approval: true,
        packingListNbr: '',
        etd: null,
        eta: null,
        flag: 'view'
      }
    }
  },
  created () {
    this.userName = window.sessionStorage.getItem('username')
    this.formInline.token = window.sessionStorage.getItem('token')
    this.getRglFileList()
    this.brandParam.userName = this.userName
    this.brandParam.userType = window.sessionStorage.getItem('userType')
    this.getRglFileNames()
    this.getPackingList()
  },
  methods: {
    async getRglFileNames () {
      const { data: res } = await this.$http.get('/show/getRglFileNames')
      this.fglFileNameSelection = await res.rglFileNames
    },
    async getRglData () {
      this.rglData = []
      console.log('this.rglData.length11111111 === ' + this.rglData.length)
      const { data: res } = await this.$http.get('/show/getRglTblData', { params: this.formInline })
      // this.rglData = await res.rglData
      if (res.rglData !== null && res.rglData.length > 0) {
        console.log('22222222222222222222 etd=== ' + res.rglData[0].eta)

        var approvaled = ''
        if (res.rglData[0].approval === 'true') {
          approvaled = 'Yes'
        } else {
          approvaled = 'No'
        }
        this.rglTbl = { rglFileName: res.rglData[0].rglfile_name, freightCost: res.rglData[0].freightCost, freightForwName: res.rglData[0].freightForwName, currency: res.rglData[0].currency, approval: approvaled, etd: res.rglData[0].etd, packingListNbr: res.rglData[0].packingListNbr, eta: res.rglData[0].eta, flag: 'view' }
        this.rglData.push(this.rglTbl)
        console.log('res.rglData.length === ' + this.rglData.length)
        // for (var i = 0; i < res.rglData.length; i++) {
        //   console.log('22222222222222222222 === ' + res.rglData.length)
        //   var approvaled = ''
        //   if (res.rglData[i].approval === 'true') {
        //     approvaled = 'Yes'
        //   } else {
        //     approvaled = 'No'
        //   }
        //   this.rglTbl = { freightCost: res.rglData[i].freightCost, freightForwName: res.rglData[i].freightForwName, currency: res.rglData[i].currency, approval: approvaled, etd: res.rglData[i].etd, packingListNbr: res.rglData[i].packingListNbr, eta: res.rglData[i].eta, flag: 'view' }
        //   this.rglData.push(this.rglTbl)
        // }
      }
    },
    objectSpanMethod ({ row, column, rowIndex, columnIndex }) {
      // console.log('row.rowIndex === ' + this.multipleSelection.length)
      // console.log('columnIndex === ' + columnIndex)
      if ((columnIndex >= 19 && columnIndex !== 26) && rowIndex === 0) {
        return {
          rowspan: this.multipleSelection.length,
          colspan: 1
        }
      }
      if (rowIndex >= 1 && (columnIndex >= 19 && columnIndex !== 26)) {
        return {
          rowspan: 0,
          colspan: 0
        }
      }
    },
    onSubmit () {
      console.log('submit!')
      this.multipleSelection = []
      this.formInline.page = 1
      this.getRglData()
      console.log('this.rglData.length111 ===' + this.rglData.length)
      this.getRglFileList()
      this.currRglName = this.formInline.fglFileName
    },
    // exportToExcel () {
    //   /* 表示在当前页面打开新地址 */
    //   window.open('http://51.68.206.7:8081/show/exportMoq?token=' + encodeURIComponent(this.formInline.token) + '&brand=' + this.formInline.brands + '&product=' + this.formInline.product + '&description=' + this.formInline.description, '_parent')
    // },
    async getRglFileList () {
      const { data: res } = await this.$http.get('/show/rfqForwarderList', { params: this.formInline })
      this.fglFileNameList = res.rows
      if (res.rows !== null && res.rows.length > 0) {
        for (var i = 0; i < res.rows.length; i++) {
          this.netCbm = this.netCbm + res.rows[i].volumn
          var approvaled = ''
          if (res.rows[i].approval === 'true') {
            approvaled = 'Yes'
          } else {
            approvaled = 'No'
          }
          this.rgl = { idx: this.index, id: res.rows[i].id, rglFileName: res.rows[i].rglfileName, status: res.rows[i].status, schDate1: res.rows[i].schDate1, supplier: res.rows[i].supplier, brand: res.rows[i].brand, intnlRef: res.rows[i].intnlRef, item: res.rows[i].item, itemDesc: res.rows[i].itemDesc, schQ1: res.rows[i].schQ1, length: res.rows[i].length, width: res.rows[i].width, height: res.rows[i].height, carton: res.rows[i].carton, nw: res.rows[i].nw, gw: res.rows[i].gw, volumn: res.rows[i].volumn, soldTo: res.rows[i].soldTo, deliveryAddr: res.rows[i].deliveryAddr, incotermCity: res.rows[i].incotermCity, freightCost: res.rows[i].freightCost, freightForwName: res.rows[i].freightForwName, currency: res.rows[i].currency, approval: approvaled, etd: res.rows[i].etd, packingListNbr: res.rows[i].packingListNbr, eta: res.rows[i].eta, flag: 'view' }
          this.multipleSelection.push(this.rgl)
          this.index++
        }
        console.log('this.multipleSelection === ' + this.multipleSelection.length)
        var cbm = this.netCbm
        this.cbmNoPrecise = this.netCbm
        this.netCbm = Math.round(this.netCbm * 100) / 100
        this.grossCbm = Math.round(cbm * 1.3 * 100) / 100
      }
      // this.total = res.total
    },
    addRfqRow () {
      this.operation = 'add'
      if (this.multipleSelection.length === 0) {
        return
      }
      // var length = this.multipleSelection.length
      this.rgl = { idx: this.index, id: -1, rglFileName: this.currRglName, status: '', schDate1: null, supplier: '', brand: '', intnlRef: '', item: '', itemDesc: '', schQ1: '', length: '', width: '', height: '', carton: '', nw: '', gw: '', volumn: '', soldTo: '', deliveryAddr: '', incotermCity: '', freightCost: '', freightForwName: '', currency: '', approval: true, packingListNbr: '', etd: null, eta: null, flag: 'add' }
      this.multipleSelection.push(this.rgl)
      this.index++
    },
    async getPackingList () {
      const { data: res } = await this.$http.get('/show/getPackingList')
      this.packingList = await res.plnList
    },
    // confirmAdd (value) {
    //   // Vue.prototype.$http = axios
    //   const { data: res } = await this.$http.get('/show/rfqForwarderList', { params: this.formInline })
    //   const that = this
    //   this.$http.get('/show/rfqForwarderSaveOne', { params: row })
    //     .then(res => {
    //       that.getTimelines()

    //       that.$message({
    //         message: '添加成功',
    //         type: 'success',
    //         duration: 500
    //       })
    //     })
    //     .catch(error => {
    //       console.log(error)
    //       that.$message({
    //         message: '添加失败',
    //         type: 'error'
    //       })
    //     })
    // },
    async addRfqRow2Db (row) {
      const that = this
      this.$confirm('Are you sure you want to add this item?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(async () => {
        // await that.confirmAdd(value)
        const { data: res } = await that.$http.post('/show/rfqForwarderSaveOne', { params: row })
        row.id = res.id
        // var cbm = this.netCbm + row.volumn
        this.cbmNoPrecise = this.cbmNoPrecise + Number(row.volumn)
        this.netCbm = Math.round(this.cbmNoPrecise * 100) / 100
        this.grossCbm = Math.round(this.cbmNoPrecise * 1.3 * 100) / 100
        if (row.approval === true) {
          row.approval = 'Yes'
        } else {
          row.approval = 'No'
        }
        // this.netCbm = this.netCbm + row.volumn
        // this.grossCbm = Math.round(this.netCbm * 1.3 * 1000000) / 1000000
        row.flag = 'view'
        // for (var i = 0; i < this.multipleSelection.length; i++) {
        //   console.log(this.multipleSelection[i].id + ',' + this.multipleSelection[i].flag)
        // }
        // this.$message({
        //   type: 'success',
        //   message: 'Delete completed!'
        // })
      }).catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: 'Delete canceled'
        // })
      })
      // m await this.$http.post('/show/rfqForwarderSaveOne', { params: row })  yyyy/mm/dd
    },
    editRfqTblRow (value) {
      this.rglData[0].flag = 'edit'
      console.log('this.rglData[0].etd === 222 ' + this.rglData[0].etd)
      // if (this.rglData[0].etd === undefined) {
      //   this.rglData[0].etd = null
      // }
      // if (this.rglData[0].eta === undefined) {
      //   this.rglData[0].eta = null
      // }
      if (this.rglData[0].etd !== undefined && this.rglData[0].etd !== null) {
        var yyyy = this.rglData[0].etd.substr(0, 4)
        var mm = this.rglData[0].etd.substr(5, 2)
        var dd = this.rglData[0].etd.substr(8, 2)
        this.rglData[0].etd = yyyy + '-' + mm + '-' + dd
      }
      if (this.rglData[0].eta !== undefined && this.rglData[0].eta !== null) {
        yyyy = this.rglData[0].eta.substr(0, 4)
        mm = this.rglData[0].eta.substr(5, 2)
        dd = this.rglData[0].eta.substr(8, 2)
        this.rglData[0].eta = yyyy + '-' + mm + '-' + dd
      }
      // for (var i = 0; i < this.multipleSelection.length; i++) {
      //   if (value === this.multipleSelection[i].id) {
      //     this.multipleSelection[i].flag = 'edit'
      //     if (this.multipleSelection[i].etd !== null) {
      //       var yyyy = this.multipleSelection[i].etd.substr(0, 4)
      //       var mm = this.multipleSelection[i].etd.substr(5, 2)
      //       var dd = this.multipleSelection[i].etd.substr(8, 2)
      //       this.multipleSelection[i].etd = yyyy + '-' + mm + '-' + dd
      //     }
      //     if (this.multipleSelection[i].eta !== null) {
      //       yyyy = this.multipleSelection[i].eta.substr(0, 4)
      //       mm = this.multipleSelection[i].eta.substr(5, 2)
      //       dd = this.multipleSelection[i].eta.substr(8, 2)
      //       this.multipleSelection[i].eta = yyyy + '-' + mm + '-' + dd
      //     }
      //     if (this.multipleSelection[i].schDate1 !== null) {
      //       var yyyy = this.multipleSelection[i].schDate1.substr(0, 4)
      //       var mm = this.multipleSelection[i].schDate1.substr(5, 2)
      //       var dd = this.multipleSelection[i].schDate1.substr(8, 2)
      //       this.multipleSelection[i].schDate1 = yyyy + '-' + mm + '-' + dd
      //     }
      //     this.oldVolumn[i] = this.multipleSelection[i].volumn
      //   }
      // }
    },
    editRfqRow (value) {
      for (var i = 0; i < this.multipleSelection.length; i++) {
        if (value === this.multipleSelection[i].id) {
          this.multipleSelection[i].flag = 'edit'
          // if (this.multipleSelection[i].etd !== null) {
          //   var yyyy = this.multipleSelection[i].etd.substr(0, 4)
          //   var mm = this.multipleSelection[i].etd.substr(5, 2)
          //   var dd = this.multipleSelection[i].etd.substr(8, 2)
          //   this.multipleSelection[i].etd = yyyy + '-' + mm + '-' + dd
          // }
          // if (this.multipleSelection[i].eta !== null) {
          //   yyyy = this.multipleSelection[i].eta.substr(0, 4)
          //   mm = this.multipleSelection[i].eta.substr(5, 2)
          //   dd = this.multipleSelection[i].eta.substr(8, 2)
          //   this.multipleSelection[i].eta = yyyy + '-' + mm + '-' + dd
          // }
          if (this.multipleSelection[i].schDate1 !== null) {
            var yyyy = this.multipleSelection[i].schDate1.substr(0, 4)
            var mm = this.multipleSelection[i].schDate1.substr(5, 2)
            var dd = this.multipleSelection[i].schDate1.substr(8, 2)
            this.multipleSelection[i].schDate1 = yyyy + '-' + mm + '-' + dd
          }
          this.oldVolumn[i] = this.multipleSelection[i].volumn
          // this.netCbm = this.netCbm - this.multipleSelection[i].volumn
        }
      }
    },
    updateRfqTblRow2Db (row) {
      const that = this
      this.$confirm('Are you sure you want to update this item?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(async () => {
        // await that.confirmAdd(value)
        await that.$http.post('/show/rfqForwarderTblUpdate', { params: row })
        // var cbm = this.netCbm - this.oldVolumn[row.idx] + row.volumn
        // this.netCbm = Math.round(cbm * 100) / 100
        // this.grossCbm = Math.round(cbm * 1.3 * 100) / 100
        if (row.approval === true) {
          row.approval = 'Yes'
        } else {
          row.approval = 'No'
        }
        // this.netCbm = this.netCbm - this.oldVolumn[row.idx] + row.volumn
        // this.grossCbm = Math.round(this.netCbm * 1.3 * 1000000) / 1000000
        row.flag = 'view'
        // for (var i = 0; i < this.multipleSelection.length; i++) {
        //   console.log(this.multipleSelection[i].id + ',' + this.multipleSelection[i].flag)
        // }
        // this.$message({
        //   type: 'success',
        //   message: 'Delete completed!'
        // })
      }).catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: 'Delete canceled'
        // })
      })
    },
    updateRfqRow2Db (row) {
      const that = this
      this.$confirm('Are you sure you want to update this item?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(async () => {
        // await that.confirmAdd(value)
        const { data: res } = await that.$http.post('/show/rfqForwarderUpdateOne', { params: row })
        this.cbmNoPrecise = this.cbmNoPrecise - Number(this.oldVolumn[row.idx]) + Number(row.volumn)
        // var cbm = this.netCbm - this.oldVolumn[row.idx] + row.volumn
        this.netCbm = Math.round(this.cbmNoPrecise * 100) / 100
        this.grossCbm = Math.round(this.cbmNoPrecise * 1.3 * 100) / 100
        if (row.approval === true) {
          row.approval = 'Yes'
        } else {
          row.approval = 'No'
        }

        // this.netCbm = this.netCbm - this.oldVolumn[row.idx] + row.volumn
        // this.grossCbm = Math.round(this.netCbm * 1.3 * 1000000) / 1000000
        row.id = res.id
        row.flag = 'view'
        // for (var i = 0; i < this.multipleSelection.length; i++) {
        //   console.log(this.multipleSelection[i].id + ',' + this.multipleSelection[i].flag)
        // }
        // this.$message({
        //   type: 'success',
        //   message: 'Delete completed!'
        // })
      }).catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: 'Delete canceled'
        // })
      })
    },
    delRfqRow (value) {
      if (this.multipleSelection.length === 1) return
      for (var i = 0; i < this.multipleSelection.length; i++) {
        if (value === this.multipleSelection[i].idx) {
          this.multipleSelection.splice(i, 1)
          // this.netCbm = this.netCbm - this.multipleSelection[i].volumn
        }
      }
    },
    confirmDelete (row) {
      // Vue.prototype.$http = axios
      const that = this
      // console.log('row.id === 111' + row.id)
      this.$http.get('/show/delRfg', { params: { value: row.id } })
        .then(res => {
          row.id = res.id
          row.flag = 'view'
          for (var i = 0; i < this.multipleSelection.length; i++) {
            if (row.idx === this.multipleSelection[i].idx) {
              this.multipleSelection.splice(i, 1)
              // this.netCbm = this.netCbm - this.multipleSelection[i].volumn
            }
          }
          that.$message({
            message: '删除成功',
            type: 'success',
            duration: 500
          })
        })
        .catch(error => {
          console.log(error)
          that.$message({
            message: '删除失败',
            type: 'error'
          })
        })
    },
    rfqTblConfirmDelete (rglFileName) {
      // Vue.prototype.$http = axios
      const that = this
      this.$http.get('/show/deleteRfgFile', { params: { value: rglFileName } })
        .then(res => {
          // row.id = res.id
          // row.flag = 'view'
          // for (var i = 0; i < this.multipleSelection.length; i++) {
          //   if (row.idx === this.multipleSelection[i].idx) {
          //     this.multipleSelection.splice(i, 1)
          //     // this.netCbm = this.netCbm - this.multipleSelection[i].volumn
          //   }
          // }
          this.rglData = []
          this.multipleSelection = []
          this.netCbm = 0
          this.grossCbm = 0
          this.getRglFileNames()
          that.$message({
            message: '删除成功',
            type: 'success',
            duration: 500
          })
        })
        .catch(error => {
          console.log(error)
          that.$message({
            message: '删除失败',
            type: 'error'
          })
        })
    },
    delRfqTbl2Db () {
      // console.log('currRglName === ' + this.currRglName)
      if (this.currRglName === null || this.currRglName === '') {
        return
      }
      const that = this
      this.$confirm('This will permanently delete the RGL File. Continue?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(async () => {
        await that.rfqTblConfirmDelete(this.currRglName)
        // this.netCbm = this.netCbm - row.volumn
        // this.grossCbm = Math.round(this.netCbm * 1.3 * 1000000) / 1000000
        // this.$message({
        //   type: 'success',
        //   message: 'Delete completed!'
        // })
      }).catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: 'Delete canceled'
        // })
      })
    },
    async delRfqRow2Db (row) {
      // console.log('row.id === ' + row.id)
      const that = this
      this.$confirm('This will permanently delete the item. Continue?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(async () => {
        await that.confirmDelete(row)
        await that.getCbmbyId(row)
        // const { data: res } = await this.$http.get('/show/getCBMbyId', { params: { value: row.id } })
        // this.cbmNoPrecise = this.cbmNoPrecise - Number(res.volumn)
        // this.netCbm = Math.round(this.cbmNoPrecise * 100) / 100
        // this.grossCbm = Math.round(this.cbmNoPrecise * 1.3 * 100) / 100
        // var cbm = this.netCbm - this.oldVolumn[row.idx] + row.volumn
        // this.netCbm = Math.round(cbm * 100) / 100
        // this.grossCbm = Math.round(cbm * 1.3 * 100) / 100
        // this.grossCbm = 0
        // this.netCbm = this.netCbm - row.volumn
        // this.grossCbm = Math.round(this.netCbm * 1.3 * 1000000) / 1000000
        // this.$message({
        //   type: 'success',
        //   message: 'Delete completed!'
        // })
      }).catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: 'Delete canceled'
        // })
      })
    },
    async getCbmbyId (row) {
      const { data: res } = await this.$http.get('/show/getCBMbyId', { params: { value: row.id } })
      this.cbmNoPrecise = this.cbmNoPrecise - Number(res.volumn)
      this.netCbm = Math.round(this.cbmNoPrecise * 100) / 100
      this.grossCbm = Math.round(this.cbmNoPrecise * 1.3 * 100) / 100
    },
    checkNum (e) {
      // const that = this
      // console.log('event.target.value === ' + e.target.value)
      if (isNaN(e.target.value)) {
        this.$alert('Please input NUMBER1 or leave blank', 'Warning', {
          confirmButtonText: 'Ok',
          callback: action => {
            // this.$message({
            //   type: 'info',
            //   message: 'aaa'
            // })
            e.target.focus()
          }
        })
      }
    },
    numFormat (row, column, cellValue, index) {
      var numrc = row[column.property]
      if (numrc === null || numrc === '') {
        return
      }
      if (numrc.toString().indexOf('.') === -1) {
        return numrc
      }
      var result = ''
      var numrcStr = numrc.toString()
      numrc = numrcStr.substring(0, numrcStr.indexOf('.') + 3)
      return result
    },
    dateFormat1 (daterc) {
      // const daterc = row[column.property]
      if (daterc === undefined || daterc === null || daterc === '' || daterc === '1753/01/01 00:00:00' || daterc === '1753-01-01 00:00:00') {
        return
      }
      var date = new Date(daterc) // long转换成date
      var year = date.getFullYear().toString()
      var month = (date.getMonth() + 1)
      var day = date.getDate().toString()
      // if (month < 10) {
      //   month = '0' + month
      // }
      var monthLetterArr = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
      var monthLetter = monthLetterArr[parseInt(month) - 1]
      if (day < 10) {
        day = '0' + day
      }
      return year + '-' + monthLetter + '-' + day
    },
    dateFormat (row, column, cellValue, index) {
      const daterc = row[column.property]
      if (daterc === null || daterc === '' || daterc === '1753/01/01 00:00:00') {
        return
      }
      var date = new Date(daterc) // long转换成date
      var year = date.getFullYear().toString()
      var month = (date.getMonth() + 1)
      var day = date.getDate().toString()
      // if (month < 10) {
      //   month = '0' + month
      // }
      var monthLetterArr = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
      var monthLetter = monthLetterArr[parseInt(month) - 1]
      if (day < 10) {
        day = '0' + day
      }
      return year + '-' + monthLetter + '-' + day
    },
    nullFormatBlank (row, column, cellValue, index) {
      const daterc = row[column.property]
      if (daterc === 'null' || daterc === null) {
        return ''
      }
    },
    handleSizeChange (val) {
      console.log(`每页 ${val} 条`)
      this.formInline.rows = val
      this.getMoqs()
    },
    handleCurrentChange (val) {
      console.log(`当前页: ${val}`)
      this.formInline.page = val
      this.getMoqs()
    },
    getMonth (month) {
      var monthLetter
      switch (month) {
        case '01':
          monthLetter = 'Jan'
          break
        case '02':
          monthLetter = 'Feb'
          break
        case '03':
          monthLetter = 'Mar'
          break
        case '04':
          monthLetter = 'Apr'
          break
        case '05':
          monthLetter = 'May'
          break
        case '06':
          monthLetter = 'Jun'
          break
        case '07':
          monthLetter = 'Jul'
          break
        case '08':
          monthLetter = 'Aug'
          break
        case '09':
          monthLetter = 'Sep'
          break
        case 10:
          monthLetter = 'Oct'
          break
        case 11:
          monthLetter = 'Nov'
          break
        case 12:
          monthLetter = 'Dec'
          break
      }
      return monthLetter
    }

  }
}
</script>

<style lang="less" scoped="scoped">
  .div-class1 {
    border:solid 1px #000;
    margin-bottom: 15px;
    padding-top:10px;
    // line-height: 50px;
  }
</style>
